import { Box, Typography } from "@mui/material";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { PriceTable } from "../../Model/PriceTableModel";

const formatPrice = (value?: number) =>
  value == null ? '' : `R$ ${value.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`

export function getColumns(priceTable: PriceTable[]) {

  // ── Desktop: 4 colunas originais ─────────────────────────────────────────────
  const columnsDesktop: GridColDef<any>[] = [
    {
      field: 'idProduct',
      headerName: 'ID',
      hideable: false,
      editable: false,
      filterable: false,
    },
    {
      field: 'name',
      headerName: 'Nome',
      flex: 1,
      editable: true,
      hideable: false,
      filterable: false,
    },
    {
      field: 'price',
      headerName: 'Preço',
      width: 150,
      editable: true,
      type: "number",
      align: 'right',
      headerAlign: 'center',
      hideable: false,
      filterable: false,
      valueGetter: (value) => value ?? value,
      valueFormatter: (value?: number) => formatPrice(value),
    },
    {
      field: 'priceTableId',
      headerName: 'Tabela',
      type: 'singleSelect',
      align: 'right',
      headerAlign: 'center',
      hideable: false,
      width: 150,
      editable: true,
      getOptionValue: (value: any) => value.id,
      getOptionLabel: (value: any) => value.name,
      valueOptions: priceTable,
    },
  ]

  // ── Mobile: 2 colunas limpas ──────────────────────────────────────────────────
  // Col 1 (flex): nome + nome da tabela abaixo (contexto sempre visível)
  // Col 2 (88px): preço editável inline em teal bold
  // Tabela é atribuída via seleção + botão "Tabela (N)" no header
  const columnsMobile: GridColDef<any>[] = [
    {
      field: 'name',
      headerName: 'Produto',
      flex: 1,
      editable: true,
      hideable: false,
      renderCell: (params: GridRenderCellParams) => {
        const table = priceTable.find(t => t.id === params.row.priceTableId)
        const tableName = table?.name && table.name !== 'Nenhuma Tabela' ? table.name : null
        return (
          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', py: 0.5, minWidth: 0 }}>
            <Typography noWrap sx={{ fontSize: 13, fontWeight: 600, color: 'text.primary', lineHeight: 1.35 }}>
              {params.row.name}
            </Typography>
            {tableName && (
              <Typography noWrap sx={{ fontSize: 11, color: 'text.disabled', lineHeight: 1.2, mt: 0.2 }}>
                {tableName}
              </Typography>
            )}
          </Box>
        )
      },
    },
    {
      field: 'price',
      headerName: 'Preço',
      width: 88,
      maxWidth: 88,
      editable: true,
      type: "number",
      align: 'left',
      headerAlign: 'left',
      hideable: false,
      valueGetter: (value) => value ?? value,
      valueFormatter: (value?: number) => formatPrice(value),
      renderCell: (params: GridRenderCellParams) => (
        <Box sx={{ display: 'flex', alignItems: 'center', height: '100%', width: '100%', pl: 0.5 }}>
          <Typography sx={{
            fontSize: 13, fontWeight: 700,
            color: params.value ? '#0d9488' : 'text.disabled',
            fontVariantNumeric: 'tabular-nums',
          }}>
            {formatPrice(params.value)}
          </Typography>
        </Box>
      ),
    },
  ]

  return [columnsDesktop, columnsMobile]
}
